import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { ManageSearch as ManageSearchIcon } from "@mui/icons-material";
import { EmptyList, LoadingList } from "@/organism";

import { AdmDto } from "@/dto/AdmDto";

/**
 * 관리자 목록 프로퍼티
 */
export type ListProps = {
  /**
   * 관리자 목록
   * @type {AdmDto[]}
   */
  list: AdmDto[];
  /**
   * 로딩 여부
   * @type {boolean}
   * @default false
   */
  isLoading?: boolean;
  /**
   * 상세 클릭 이벤트
   * @type {(admIdntfcId: number) => void}
   */
  onDetail: (admIdntfcId: number) => void;
};

/**
 * 관리자 목록 컴포넌트
 *
 * @param {ListProps} props
 * @returns {JSX.Element}
 *
 * @author bart <bart@ymjlab.com>
 * @since 2024-12-23
 * @version 1.0
 */
export const List = (props: ListProps) => {
  const { list, isLoading = false, onDetail } = props;

  const renderContent = () => {
    if (isLoading) {
      return <LoadingList />;
    }

    if (list.length === 0) {
      return <EmptyList />;
    }

    return list.map((adm: AdmDto) => (
      <TableRow key={adm.admIdntfcId}>
        <TableCell>{adm.admIdntfcId}</TableCell>
        <TableCell>{adm.admId}</TableCell>
        <TableCell>{adm.admNm}</TableCell>
        <TableCell>{adm.admAuth}</TableCell>
        <TableCell>{adm.useYn}</TableCell>
        <TableCell>
          <IconButton
            color={"default"}
            onClick={() => onDetail(adm.admIdntfcId)}
          >
            <ManageSearchIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <Paper variant={"outlined"}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>아이디</TableCell>
              <TableCell>관리자명</TableCell>
              <TableCell>권한</TableCell>
              <TableCell>사용여부</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderContent()}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
